import { localized } from "js/includes/common/utils"
import { evolve } from "ramda"

export const OccurrenceDurationOptions = {
  value: 5,
  items: [
    { value: 5, text: () => `5 ${localized("general.minutes").toLowerCase()}` },
    { value: 15, text: () => `15 ${localized("general.minutes").toLowerCase()}` },
    { value: 30, text: () => `30 ${localized("general.minutes").toLowerCase()}` },
    { value: 60, text: () => `60 ${localized("general.minutes").toLowerCase()}` },
  ],
}

export const ResetThresholdOptions = {
  value: 4,
  items: [
    { value: 0.025, text: () => `90 ${localized("general.seconds")}` },
    { value: 0.05, text: () => `3 ${localized("general.minutes").toLowerCase()}` },
    { value: 0.1, text: () => `6 ${localized("general.minutes").toLowerCase()}` },
    { value: 0.2, text: () => `12 ${localized("general.minutes").toLowerCase()}` },
    { value: 0.3, text: () => `18 ${localized("general.minutes").toLowerCase()}` },
    { value: 0.4, text: () => `20 ${localized("general.minutes").toLowerCase()}` },
    { value: 0.5, text: () => `30 ${localized("general.minutes").toLowerCase()}` },
    { value: 1, text: () => `1 ${localized("general.hour").toLowerCase()}` },
    { value: 2, text: () => `2 ${localized("general.hours").toLowerCase()}` },
    { value: 4, text: () => `4 ${localized("general.hours").toLowerCase()}` },
    { value: 8, text: () => `8 ${localized("general.hours").toLowerCase()}` },
    { value: 12, text: () => `12 ${localized("general.hours").toLowerCase()}` },
    { value: 24, text: () => `24 ${localized("general.hours").toLowerCase()}` },
    { value: 596523, text: () => localized("general.manual"), manual: true },
  ],
}

const getThresholdItemsWithoutManual = () => ResetThresholdOptions.items.filter(item => !item.manual)

export const ResetThresholdOptionsWithoutManual = evolve(
  { items: getThresholdItemsWithoutManual },
  ResetThresholdOptions,
)

export const TicketingOptions = {
  value: "NONE",
  items: [
    { value: "NONE", text: () => localized("general.doNotCreateTicket") },
    { value: "CREATE", text: () => localized("general.createTicket") },
    { value: "CREATE_AND_CLOSE", text: () => localized("general.createCloseTicket") },
  ],
}

export const NotificationOptions = {
  value: "NONE",
  items: [
    { value: "NONE", text: () => localized("general.doNotSendNotifications") },
    { value: "SEND", text: () => localized("general.sendNotifications") },
  ],
}

export const SeverityOptions = {
  value: null,
  items: [
    { value: "CRITICAL", text: () => localized("general.critical") },
    { value: "MAJOR", text: () => localized("general.major") },
    { value: "MODERATE", text: () => localized("general.moderate") },
    { value: "MINOR", text: () => localized("general.minor") },
    { value: null, text: () => localized("general.none") },
  ],
}

export const PriorityOptions = {
  value: null,
  items: [
    { value: "HIGH", text: () => localized("editors.policy.conditions.high") },
    { value: "MEDIUM", text: () => localized("general.medium") },
    { value: "LOW", text: () => localized("general.low") },
    { value: null, text: () => localized("general.none") },
  ],
}
